// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-24mFF","transactions":"transactions-1WYW1"};